export const LOG_OUT = 'LOG_OUT';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const LOADER = 'LOADER';

export const getInitials = (name) => {
  if (!name) return "";
  const words = name.trim().split(" ");
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

export const phaseOptions = [
  { label: 'Menstrual', value: 'Menstrual' },
  { label: 'Follicular', value: 'Follicular' },
  { label: 'Ovulation', value: 'Ovulation' },
  { label: 'Luteal', value: 'Luteal' },
];
export const topicOptions = [
  { label: 'Period & Cycle', value: 'Period & Cycle' },
  { label: 'Mental Health', value: 'Mental Health' },
  { label: 'Physical Health & Fitness', value: 'Physical Health & Fitness' },
  { label: 'Nutrition & Recipes', value: 'Nutrition & Recipes' },
  { label: 'Intimacy, Sex & Pleasure', value: 'Intimacy, Sex & Pleasure' },
  { label: 'My Relationships', value: 'My Relationships' },
  { label: 'Fertility/Pregnancy', value: 'Fertility/Pregnancy' },
  { label: 'Mum Life', value: 'Mum Life' },
  { label: 'Creative/Fun', value: 'Creative/Fun' }
];
